import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'

interface LocationHistoryContextType {
  locationHistory: string[]
}

const LocationHistoryContext = createContext<LocationHistoryContextType>({ locationHistory: [] })

interface NavigationHistoryProviderProps {
  children: React.ReactNode
}

export const LocationHistoryProvider = ({ children }: NavigationHistoryProviderProps) => {
  const location = useLocation()

  const [locationHistory, setLocationHistory] = useState<string[]>(() => [location.pathname])

  useEffect(() => {
    setLocationHistory(prevHistory => [...prevHistory, location.pathname])
  }, [location.pathname])

  const contextValue = useMemo(() => ({ locationHistory }), [locationHistory])

  return <LocationHistoryContext.Provider value={contextValue}>{children}</LocationHistoryContext.Provider>
}

export const useLocationHistory = () => {
  const locationHistoryContext = useContext(LocationHistoryContext)

  if (!locationHistoryContext) {
    throw new Error('useLocationHistory must be used within an LocationHistoryProvider')
  }

  return locationHistoryContext
}
